module.exports = __webpack_public_path__ + "img/bank8.23b4a71d.png";